export default "__VITE_ASSET__CaaGigka__"